import styled, { keyframes } from 'styled-components';
import { white } from 'styles/Colors';

const LeftToRight = keyframes`
0% {
        transform: translateX(2%);
    }
    100% {
        transform: translateX(198%);
    }
`;

export const LinearLoaderContainer = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
`;

export const LinearLoaderWrapper = styled.div`
  background-color: ${white};
  height: 8px;
  overflow: hidden;
  border-radius: 9999px;
  display: table-cell;
  vertical-align: middle;
  width: 137px;
`;

export const Bar = styled.div`
  animation: ${LeftToRight} 1s alternate infinite cubic-bezier(0.65, 0, 0.35, 1);
  background: linear-gradient(140.12deg, #fe9800 0%, #ffc900 100%);
  width: 33.33%;
  height: 6px;
  border-radius: 9999px;
  overflow: hidden;
`;
